import { Input } from '@perch-labs/shrike';
import { useEffect, useMemo, useState } from 'react';
import { Button } from '~/components/button';
import { setValueByName } from './dev-tools.utils';
import { PerchProductPicker } from './perch-product-picker.component';
// @ts-expect-error TS doesn't like direct JSON imports - need to adjust the tsconfig
import utilityData from './utility-dropdown-data.json';

type UtilityRow = (typeof utilityData)[number];

export type AutofillUtilitiesProps = {
  funnelId: string;
  /** When true, Perch funnel shows product picker tied to Demo Tools utility choice (utility step only). */
  showPerchProductPicker?: boolean;
};

const funnelUtilities = {
  communityHousingPartners: ['Dominion Energy VA'],
  communitySolar: ['National Grid NY'],
  conference: ['National Grid RI'],
  isolarUcb: ['Central Hudson Gas & Electric'],
  membership: ['Pacific Gas & Electric'],
  oregonTier1: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier2: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier1Lmi: ['Pacific Power OR', 'Portland General Electric'],
  oregonTier2Lmi: ['Pacific Power OR', 'Portland General Electric'],
  perchEnergy: ['National Grid NY'],
  solar: ['Baltimore Gas & Electric'],
  solarLandscape: ['Jersey Central Power & Light'],
  telesales: ['National Grid NY'],
  powersetter: ['National Grid NY'],
  sponsoredSolar: ['Ohio Edison'],
  waitlist: ['Public Service Company of NM'],
  mnLmi: ['Xcel Energy MN'],
};

export const AutofillUtilities = ({
  funnelId,
  showPerchProductPicker = false,
}: AutofillUtilitiesProps) => {
  const [inputValue, setInputValue] = useState('');

  const sortedUtilities = useMemo(
    () => sortList(utilityData as UtilityRow[], funnelUtilities[funnelId]),
    [funnelId],
  );

  const matchedByName = useMemo(
    () => (utilityData as UtilityRow[]).find(u => u.name === inputValue),
    [inputValue],
  );

  useEffect(() => {
    const selected = (utilityData as UtilityRow[]).find(u => u.name === inputValue);
    if (selected) setValueByName('zipCode', selected.zip);
  }, [inputValue]);

  return (
    <>
      <Button
        mode="primary"
        onClick={() => {
          const u = sortedUtilities[0];
          setValueByName('zipCode', u.zip);
          setInputValue(u.name);
        }}
      >
        {sortedUtilities[0].name}
      </Button>
      <Input
        label="Search utilities"
        list="utilities"
        name="utilityDataList"
        onChange={setInputValue}
        value={inputValue}
      />
      <datalist id="utilities" style={{ width: '100px' }}>
        {sortedUtilities.map(u => (
          <option key={u.id} value={u.name} label={u.name} />
        ))}
      </datalist>
      {showPerchProductPicker ? (
        <PerchProductPicker
          stateAbbreviation={matchedByName?.abbreviation}
          utilityId={matchedByName != null ? Number(matchedByName.id) : 0}
        />
      ) : null}
    </>
  );
};

const sortList = (utilityData: UtilityRow[], funnelUtilities: string[] | undefined) => {
  const sorted = [...utilityData].sort((a, b) => b.weight - a.weight);
  return [
    ...sorted.filter(u => (funnelUtilities || []).includes(u.name)),
    ...sorted.filter(u => !(funnelUtilities || []).includes(u.name)),
  ];
};
